module.exports = __webpack_public_path__ + "static/media/HRECOS_PANEL_SALT.97f86777.png";